module.exports = __webpack_public_path__ + "img/sy.e2e206aa.svg";